import styled from 'styled-components'

export const DashboardContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 40px - 1rem);

  display: flex;
  column-gap: 1rem;
`
